import { useSpotlight } from '@/hooks/onboarding/useSpotlight';
import { TourSpotlight } from './TourSpotlight';
import { TourPopover } from './TourPopover';
import type { TourStep } from './types';
import type { WizardSummary } from '@/hooks/onboarding/useOnboardingSync';

interface TourRendererProps {
  currentStep: TourStep | null;
  currentIndex: number;
  totalSteps: number;
  isActive: boolean;
  wizardSummary: WizardSummary | null;
  onNext: () => void;
  onPrev: () => void;
  onSkip: () => void;
}

export function TourRenderer({
  currentStep,
  currentIndex,
  totalSteps,
  isActive,
  wizardSummary,
  onNext,
  onPrev,
  onSkip,
}: TourRendererProps) {
  const { rect } = useSpotlight(isActive && currentStep ? currentStep.target : null);

  return (
    <>
      <TourSpotlight
        targetRect={rect}
        padding={currentStep?.highlightPadding ?? 8}
        isActive={isActive}
        onOverlayClick={onSkip}
      />
      <TourPopover
        step={currentStep}
        stepIndex={currentIndex}
        totalSteps={totalSteps}
        targetRect={rect}
        wizardSummary={wizardSummary}
        onNext={onNext}
        onPrev={onPrev}
        onSkip={onSkip}
        isActive={isActive}
      />
    </>
  );
}
